module.exports = "<h2>{{ book.name }} Details</h2>\n<div><span>uuid: </span>{{book.uuid}}</div>\n<div><span>name: </span>{{book.name}}</div>\n"


//////////////////
// WEBPACK FOOTER
// /home/shalom/sandbox/kidlendinglibrary/kidlendinglibrary/src/app/books/books.component.html
// module id = ../../../../../src/app/books/books.component.html
// module chunks = main